var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlacementActive = function SvgPlacementActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8615 2.79329C6.66774 -0.931096 12.8323 -0.931096 16.6385 2.79329C20.4538 6.52658 20.4538 12.5863 16.6385 16.3196L16.6269 16.3307L10.263 22.2971C9.97447 22.5676 9.52553 22.5676 9.23703 22.2971L2.87307 16.3307L2.8615 16.3196C-0.953835 12.5863 -0.953835 6.52658 2.8615 2.79329ZM15.5894 3.86541C12.3662 0.711529 7.13377 0.711529 3.91057 3.86541C0.698342 7.00857 0.696477 12.0966 3.90498 15.242L9.75 20.7219L15.595 15.242C18.8035 12.0966 18.8017 7.00857 15.5894 3.86541Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82349 9.67449C5.82349 7.51473 7.58739 5.77464 9.74996 5.77464C11.9125 5.77464 13.6764 7.51473 13.6764 9.67449C13.6764 11.8343 11.9125 13.5743 9.74996 13.5743C7.58739 13.5743 5.82349 11.8343 5.82349 9.67449ZM9.74996 7.27464C8.40389 7.27464 7.32349 8.35503 7.32349 9.67449C7.32349 10.994 8.40389 12.0743 9.74996 12.0743C11.096 12.0743 12.1764 10.994 12.1764 9.67449C12.1764 8.35503 11.096 7.27464 9.74996 7.27464Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlacementActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placement-active.d9818e15.svg";
export { ForwardRef as ReactComponent };